
import { PropType } from 'vue'
import NrIconButton from '../NrIconButton/nr-icon-button.vue'
import NrIcon from '../NrIcon/NrIcon.vue'

export default {
  name: 'NrTag',
  props: {
    label: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'normal'
    },
    tagColor: {
      type: String,
      default: 'black'
    },
    iconColor: {
      type: String,
      default: 'black'
    },
    icon: {
      type: String,
      default: ''
    },
    clickable: {
      type: Boolean,
      default: false
    },
    iconType: {
      type: String as PropType<'regular' | 'solid'>,
      default: 'regular'
    },
    iconPosition: {
      type: String,
      default: 'right'
    },
    ariaLabel: {
      type: String,
      default: 'toggle'
    },
    badge: {
      type: Boolean,
      default: false
    }
  },
  components: {
    NrIcon,
    NrIconButton
  },
  computed: {
    classNames() {
      let tagClasses = [
        'nr-tag',
        `nr-tag--${this.size}`,
        `nr-tag--badge-${this.badge}`,
        `nr-tag--${this.tagColor}`
      ]
      if (this.icon) {
        tagClasses = [
          ...tagClasses,
          `nr-tag--icon-position-${this.iconPosition}`,
          `nr-tag--icon-${!!this.icon}`,
          `nr-tag--icon-clickable-${this.clickable}`
        ]
      }
      return tagClasses
    }
  }
}
